import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function DownArrowIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="8"
        height="6"
        viewBox="0 0 8 6"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.42897 5.68455C3.74448 6.10715 4.2584 6.10315 4.57033 5.68455L7.66816 1.52853C8.29738 0.684344 8.00422 0 7.02196 0H0.977339C-0.00849784 0 -0.294507 0.689339 0.331138 1.52853L3.42897 5.68455Z"
        />
      </svg>
    </Icon>
  );
}
